import dayjs from 'dayjs'

export default function useDate() {
  const beforeToday = (date: Date | string) => {
    const now = dayjs()
    const nowFormatted = dayjs(now).format('YYYY-MM-DD')
    const dateFormatted = dayjs(date).format('YYYY-MM-DD')
    return dateFormatted < nowFormatted
  }

  const formatDate = (formatDate: { date?: string; initialFormat?: string; toFormat?: string }) => {
    return dayjs(formatDate.date, formatDate.initialFormat).format(formatDate.toFormat)
  }

  const localDate = (date: Date) => {
    return new Date(date).toLocaleDateString('fr-FR')
  }

  const subtractDate = (value: number, date: dayjs.ManipulateType, toFormat: string) => {
    return dayjs().subtract(value, date).format(toFormat)
  }

  const formatTime = (date: Date) => {
    return new Date(date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
  }

  const formatFromArrayToDatePicker = (initialDates: string[]) => {
    return initialDates.map((date) => dayjs(date, 'YYYY-MM-DD').format('DD/MM/YYYY'))
  }

  const formatDatePickerToStringArray = (initialDate: string) => {
    if (dayjs(initialDate, 'DD/MM/YYYY').isValid()) {
      return dayjs(initialDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }
  }

  return {
    beforeToday,
    formatDate,
    formatTime,
    localDate,
    subtractDate,
    formatFromArrayToDatePicker,
    formatDatePickerToStringArray
  }
}
